import React, { Dispatch, SetStateAction, useState } from 'react'
import { Route, Routes } from 'react-router-dom'
import styled from 'styled-components'
import { LINKS, relPath } from '../../../../Routs/config'
import CreateMiun from './Create/CreateMiun'
import MiunLines from './MiunLines/MiunLines'
import CreateSorting from './modal/CreateSorting'
import { AppModal } from '../../../../generic/ui/Modal'
import useDataFetcher from '../knisot/hooks/useFetchData'
import { Defaults } from '../../../../modules/API/Defaults/defaults'
import { IProductListNodeResponse } from '../../../../modules/API/Defaults/models/productListNode'
import { IGrowerNodeGetResponse } from '../../../../modules/API/Defaults/models/growers'
import { IWarhouseListItem } from '../../../../modules/API/Defaults/models/warhouseList'
import useMiunList from './services/hooks/useMiunList'
import MiunPageLayout from './Components/MiunPageLayout'
import MiunSortingCard from './Components/MiunSortingCard'
import { DateRangePicker } from '../../../../generic/ui/DatePicker'
import { SearchInput } from '../../../../generic/ui/SearchInput'
import { Surface, ScrollArea } from '../../../../generic/ui/Surface'
import { Loader } from '../../../../generic/ui/Loader'
import { CreateButton, CreateFab } from '../../../../generic/ui/CreateButton'
import { parse } from 'date-fns'

const parseDateParam = (s: string): Date => parse(s, 'yyyyMMdd', new Date())

const ListView: React.FC = () => {
    const { from, to, setRange, renderData, isLoading, input, setInput, uppendData } =
        useMiunList()

    const [isOpenCreateSorting, setIsOpenCreateSorting] = useState<boolean>(false)

    const { data: productList } = useDataFetcher<IProductListNodeResponse>(
        Defaults.getProductListNode,
        '123',
    )
    const { data: dataGrowers } = useDataFetcher<IGrowerNodeGetResponse>(
        Defaults.getGrowerList,
        'data',
    )
    const { data: warhouseList } = useDataFetcher<IWarhouseListItem[]>(
        Defaults.getWarhouseList,
        'data',
    )

    const handleModalCreateSorting = () => setIsOpenCreateSorting((v) => !v)

    const setDateFrom: Dispatch<SetStateAction<string>> = (next) => {
        const v = typeof next === 'function' ? (next as (p: string) => string)(from) : next
        if (v !== from) setRange(v, to)
    }
    const setDateTo: Dispatch<SetStateAction<string>> = (next) => {
        const v = typeof next === 'function' ? (next as (p: string) => string)(to) : next
        if (v !== to) setRange(from, v)
    }

    const isEmpty = !renderData || renderData.length < 1
    const lastIndex = (renderData?.length ?? 0) - 1

    return (
        <MiunPageLayout title='תעודות מיון'>
            <BarRow>
                <CreateButton
                    label='מיון חדש'
                    onClick={handleModalCreateSorting}
                />
                <SelectBarShell>
                    <SearchInput
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder='חיפוש'
                    />
                    <DateRangePicker
                        selected={[parseDateParam(from), parseDateParam(to)]}
                        setDate={setDateFrom}
                        setDateEnd={setDateTo}
                    />
                </SelectBarShell>
            </BarRow>

            <Surface>
                <ScrollArea>
                    {isLoading ? (
                        <CenterState>
                            <Loader size={56} />
                        </CenterState>
                    ) : isEmpty ? (
                        <EmptyState>
                            <img src='/images/no-data.png' alt='empty data' />
                        </EmptyState>
                    ) : (
                        renderData.map((item, idx) => (
                            <MiunSortingCard
                                key={item.id ?? item.Sorting_Num}
                                item={item}
                                isLast={idx === lastIndex}
                            />
                        ))
                    )}
                </ScrollArea>
            </Surface>

            <CreateFab label='מיון חדש' onClick={handleModalCreateSorting} />

            {isOpenCreateSorting && (
                <AppModal
                    title='יצירת תעודת מיון'
                    Children={CreateSorting}
                    childrenProps={{
                        productList: productList?.products || [],
                        dataGrowers: dataGrowers?.growers || [],
                        warhouseList: warhouseList || [],
                        uppendData,
                        closeFunc: handleModalCreateSorting,
                    }}
                    controlFunc={handleModalCreateSorting}
                />
            )}
        </MiunPageLayout>
    )
}

const MiunMain: React.FC = () => (
    <Routes>
        <Route index element={<ListView />} />
        <Route
            path={relPath(LINKS.miun.control.create, LINKS.miun.control.mainURL)}
            element={<CreateMiun />}
        />
        <Route
            path={relPath(LINKS.miun.control.lines, LINKS.miun.control.mainURL)}
            element={<MiunLines />}
        />
    </Routes>
)

export default MiunMain

const BarRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
`

const SelectBarShell = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
`

const EmptyState = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
`

const CenterState = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
`
